module.exports = __webpack_public_path__ + "img/JMMP_Website_Projects_Typefaces_03_JM-07.0c10e396.svg";